import { render, staticRenderFns } from "./NoteSidebar.vue?vue&type=template&id=2cfa00fb"
import script from "./NoteSidebar.vue?vue&type=script&lang=js"
export * from "./NoteSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports